module.exports = __webpack_public_path__ + "static/media/dec9gig.51f16c8f.jpeg";